"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Split = _interopRequireDefault(require("./templates/Split"));
var _Single = _interopRequireDefault(require("./templates/Single"));
var _constants = require("../../constants");
var templates = {
  Split: _Split["default"],
  Single: _Single["default"]
};
var FlexTextDecorationRow = function FlexTextDecorationRow(props) {
  var _useInView = (0, _reactIntersectionObserver.useInView)({
      rootMargin: _constants.LAZY_LOAD_OFFSET,
      triggerOnce: true
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  var template = props.data.template || 'Split';
  var TemplateSelected = templates[template];
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    className: "max-width-sm"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: "ftdr"
  }, /*#__PURE__*/_react["default"].createElement(TemplateSelected, (0, _extends2["default"])({}, props, {
    inView: inView
  }))));
};
FlexTextDecorationRow.propTypes = {
  data: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = FlexTextDecorationRow;